import React, { useEffect, useState, useRef } from "react";
import { Row, Col } from "reactstrap";
import { Modal, Button } from 'react-bootstrap';
import Slider from "react-slick";
import axiosConn from "config/axiosConn";
import { BiSolidLike, BiSolidDislike } from "react-icons/bi";
import subThemes from "helper/SubThemes_List";
import ThemeBaseRouting from "helper/ThemeBaseRouting";
import StateList from "../../../helper/State_List.json";
import DistrictList from "../../../helper/District_List.json";
import { useLocation, useNavigate } from "react-router-dom";
import AdminViewTable from "./AdminViewTable";
import { FaTable, FaFilter } from "react-icons/fa";
import { CiBoxList } from "react-icons/ci";
import { IoMdArrowRoundBack } from "react-icons/io";
import Helper from "../../../helper/Common_Helper"
import { toast } from "react-toastify";
import { FaAngleDown } from "react-icons/fa6";


function DistrictViewTheme() {
  const navigate = useNavigate();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const [timeFilter, setTimeFilter] = useState(false)
  const [quickNum, setQuickNum] = useState("")
  const [modalShow, setModalShow] = useState(false);
  const [eventsData, setEventsData] = useState([]);
  const [stateID, setStateID] = useState('');
  const [mediaUrl, setMediaUrl] = useState('');
  const [isVideo, setIsVideo] = useState(false);
  const [tableView, setTableView] = useState(false);
  const [filterDistrict, setFilterDistrict] = useState([]);
  const [filteredSchool, setFilteredSchool] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isFilterShow, setIsFilterShow] = useState(false);
  const [selectYear, setYear] = useState('');
  const [filterData, setFilterData] = useState(location?.state?.data || {
    state: "",
    district: "",
    theme_name: "",
    sub_themes: "",
    school_name: "",
    implemnt_mode: "",
    event_type: "",
    fromDate: "",
    toDate: ""
  })

  const params = new URLSearchParams(location.search);
  const storedState =  localStorage.getItem('filterDataState');
  const themesName = params.get('themeLabel') || localStorage.getItem('theme_name');
  const status = params.get('status') || localStorage.getItem('status');

  useEffect(() => {
    getThemeList(filterData, currentPage);
  }, [filterData, currentPage]);

  useEffect(() => {
    let StateId = StateList.find(obj => obj.state_name == filterData.state)?.state_id;
    let filterdistrictList = DistrictList.filter(obj => obj.state_id == StateId);
    setFilterDistrict(filterdistrictList);
  }, [])
  
  const themeLabel = location.state?.themeLabel;

  const getThemeList = async (data, page = 1) => {
    try {
      data['page'] = page;
      data['limit'] = tableView === true ? 9 : 10;
      data['district'] = filterData.district;

    if ((themeLabel && (storedState === 0 || storedState === undefined || storedState === null))) {
      console.log('74');
        data['state'] = 0;
        data['theme_name'] = themeLabel;
    } else if (storedState && (themeLabel === 0 || themeLabel === undefined)) {
      console.log('79');
      if (!data['district'] || data['district'] === " ") {
        data['theme_name'] = themesName;
      }
        data['state'] = storedState;
        data['status'] = status;
    } else if (themeLabel && storedState) {
      console.log('84');
        data['theme_name'] = themeLabel;
    }  
    console.log('86868686868686------',data);
      const response = await fetch('https://ecoclubs.education.gov.in/api/get-admin-themes', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      const responseData = await response.json();
      console.log('responseData', responseData);
      if (response.ok && responseData.status === "success") {
        const transformedEvents = responseData.data;
        setEventsData(transformedEvents);
        setTotalPages(responseData.totalPages);
        setCurrentPage(responseData.currentPage);
      }
    } catch (error) {
      console.log(error);
    }
  }

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
      getThemeList(filterData, page);
    }
  };

  const handleMediaClick = (url, type) => {
    setMediaUrl(url);
    setIsVideo(type === 'video');
    setModalShow(true);
  };

  const handleSelectState = (data) => {
    setStateID(data);
    setFilteredSchool([])
    let StateName = StateList.find(obj => obj.state_id == data)?.state_name;
    let filterdistrictList = DistrictList.filter(obj => obj.state_id == data);
    setFilterDistrict(filterdistrictList);
    setFilterData(prevData => ({ ...prevData, state: StateName, district: '', school_name: "" }));
    getSchoolList({ state_id: data })
  }

  const handleSelectDistrict = async (value) => {
    setFilteredSchool([])
    setFilterData(prevData => ({ ...prevData, district: value, school_name: "" }));
    let districtid = DistrictList.find(obj => obj.district_name == value)?.district_id;
    getSchoolList({ state_id: stateID, district_id: districtid })
  }
  const handleSelectTheme = async (value) => {
    setFilterData(prevData => ({ ...prevData, theme_name: value, sub_themes: "" }));
  }

  const handleFilterChange = (field, value) => {
    if (field === "toDate") {
      if (filterData?.fromDate && new Date(filterData?.fromDate) > new Date(value)) {
        toast.error('Start date cannot be greater than end date');
        return;
      }
    }
    setFilterData(prevData => ({ ...prevData, [field]: value }));
  }
  
  useEffect(() => {
    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setTimeFilter(false);
        }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);

  const getSchoolList = async (data) => {
    try {
      let response = await axiosConn('post', 'get-school-filter', data)
      if (response.data.status === 'success') {
        setFilteredSchool(response.data.result)
      }
    } catch (error) {
      console.log(error);
    }
  }

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const applyQuickSelect = (quickSelect) => {
    const today = new Date();
    let startDate = null;
    let endDate = new Date();

    const quickSelectRanges = {
        last3Days: () => {
            startDate = new Date(today);
            startDate.setDate(today.getDate() - 3);
        },
        last7Days: () => {
            startDate = new Date(today);
            startDate.setDate(today.getDate() - 7);
        },
        last15Days: () => {
            startDate = new Date(today);
            startDate.setDate(today.getDate() - 15);
        },
        lastMonth: () => {
            startDate = new Date(today);
            startDate.setMonth(today.getMonth() - 1);
        },
        last3Months: () => {
            startDate = new Date(today);
            startDate.setMonth(today.getMonth() - 3);
        },
        last6Months: () => {
            startDate = new Date(today);
            startDate.setMonth(today.getMonth() - 6);
        },
        currentYear: () => {
            startDate = new Date(today.getFullYear(), 0, 1);
        },
        previousYear: () => {
            startDate = new Date(today.getFullYear() - 1, 0, 1);
            endDate = new Date(today.getFullYear() - 1, 11, 31);
        },
    };

    if (quickSelectRanges[quickSelect]) {
        quickSelectRanges[quickSelect]();
    } else {
        return;
    }

    setFilterData(prevData => ({
        ...prevData,
        fromDate: startDate.toISOString().split('T')[0],
        toDate: endDate.toISOString().split('T')[0]
    }));
    setTimeFilter(false);
};

const handleQuickSelect = (period) => {
  applyQuickSelect(period);
};


  // Function to calculate start and end dates of the selected year
  const calculateYearRange = (year) => {
    if (!year) return { start: '', end: Helper.currentOrPastDate() };
    const startDate = `${year}-01-01`;
    const endDate = `${year}-12-31`;
    return { start: startDate, end: endDate };
  };
  // Calculate the date range for the selected year
  const { start, end } = calculateYearRange(selectYear);
 

  return (
    <>
      <div className="content superAdminDashboardSec">
        <div className="dashbrdTopSrchDiv mt-3 mb-1">
          <h2>Events<span className="hdngBrkr">   Details</span></h2>
          <div className="text-end">
            <Button style={{ marginRight: '3px' }} onClick={() => setIsFilterShow(!isFilterShow)}><FaFilter size={20} color="#dddddd" /> Filter</Button>
            <Button onClick={() => navigate(`/admin/level-2?state=${storedState}`)}><IoMdArrowRoundBack size={20} color="#dddddd" /> Back</Button>
          </div>
          {isFilterShow && (
            <div className="filter my-4">
              <div className="container-fluid">
                <div className="row gy-3">
                  <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                    <div className="card-stats card">
                      <select name="state" className="form-control" value={StateList.find(list => list.state_name == filterData.state)?.state_id || ''} onChange={(e) => handleSelectState(e.target.value)} disabled>
                        <option value="">All States/UTs/ABs</option>
                        {StateList.map((list, i) => (
                          <option key={i} value={list.state_id}>{list.state_name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                    <div className="card-stats card">
                      <select name="district" className="form-control" value={filterData.district} onChange={(e) => { handleSelectDistrict(e.target.value) }}>
                        <option value="">All District</option>
                        {filterDistrict.map((list, i) => (
                          <option key={i} value={list.district_name}>{list.district_name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                    <div className="card-stats card">
                      <select name="school_name" className="form-control" value={filterData.school_name} onChange={(e) => handleFilterChange('school_name', e.target.value)}>
                        <option value="">All School</option>
                        {filteredSchool && filteredSchool.map((school, i) => (
                          <option key={i} value={school.school_name}>{school.school_name}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                    <div className="card-stats card">
                      <select name="theme_name" className="form-control" value={filterData.theme_name} onChange={(e) => { handleSelectTheme(e.target.value) }}>
                        <option value="">All Theme</option>
                        {ThemeBaseRouting.map((list, i) => (
                          <option value={list.value}>{list.lable}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                    <div className="card-stats card">
                      <select name="sub_themes" className="form-control" value={filterData.sub_themes} onChange={(e) => handleFilterChange('sub_themes', e.target.value)}>
                        <option value="">All Sub Theme</option>
                        {filterData.theme_name && subThemes[filterData.theme_name]?.map((list, i) => (
                          <option value={list.value}>{list.label}</option>
                        ))}
                      </select>
                    </div>
                  </div>

                  {/* <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-3">
                    <div className="card-stats card">
                      <select name="selectYear" className="form-control" value={selectYear}
                        onChange={(e) => { setYear(e.target.value); setFilterData(prevData => ({ ...prevData, fromDate: "", toDate: "" })); }}>
                        <option value="">All Years</option>
                        <option value="2023">2023</option>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                      </select>
                    </div>
                  </div>

                  <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-1">
                    <label style={{ marginTop: '10px' }} htmlFor="fromDate">
                      From Date
                    </label>
                  </div>

                  <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-2">
                    <div className="card-stats card">
                      <input type="date" name="fromDate" min={start || ''} max={end || Helper.currentOrPastDate()} className="form-control"
                        value={filterData.fromDate} onChange={(e) => handleFilterChange('fromDate', e.target.value)} />
                    </div>
                  </div>

                  <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-1">
                    <label style={{ marginTop: '10px' }} htmlFor="toDate">
                      To Date
                    </label>
                  </div>

                  <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-2">
                    <div className="card-stats card">
                      <input type="date" name="toDate" min={start || ''}
                        max={end || Helper.currentOrPastDate()} className="form-control" value={filterData.toDate} onChange={(e) => handleFilterChange('toDate', e.target.value)} />
                    </div>
                  </div> */}
                  {/* <div className="srchBx _sr1 col-12 col-sm-6 col-md-6 col-lg-6">
                                            <div className="card-stats" ref={dropdownRef}>
                                                <button className="buttongreen form-control d-flex justify-content-between align-items-center" onClick={() => setTimeFilter(!timeFilter)}>Select Duration <FaAngleDown /></button>
                                                {timeFilter ? (
                                                    <div className="contentTime d-flex justify-content-between align-items-start flex-wrap">
                                                        <div className="leftArea">
                                                            <h5 className="text-center">Absolute time range</h5><hr />
                                                            <div className="card-stats">
                                                                <select name="selectYear" className="form-control" value={selectYear}
                                                                    onChange={(e) => { setYear(e.target.value); setFilterData({ fromDate: '', toDate: '' }); }}>
                                                                    <option value="">All Years</option>
                                                                    <option value="2023">2023</option>
                                                                    <option value="2024">2024</option>
                                                                    <option value="2025">2025</option>
                                                                </select>
                                                            </div>
                                                            <div className="srchBx _sr1 w-100">
                                                                <label style={{ marginTop: '10px' }} htmlFor="fromDate">From Date</label>
                                                                <input type="date" name="fromDate" min={start || ''} max={end || Helper.currentOrPastDate()}
                                                                    className="form-control" value={filterData.fromDate}
                                                                    onChange={(e) => handleFilterChange('fromDate', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="srchBx _sr1 w-100">
                                                                <label style={{ marginTop: '10px' }} htmlFor="toDate">To Date</label>
                                                                <input type="date" name="toDate" min={filterData.fromDate || ''}
                                                                    max={end || Helper.currentOrPastDate()} className="form-control"
                                                                    value={filterData.toDate} onChange={(e) => { handleFilterChange('toDate', e.target.value); setTimeFilter(false) }}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="RightArea">
                                                            <h5 className="text-center">Quick Ranges</h5>
                                                            <hr />
                                                            <ul>
                                                                <li className={quickNum === 1 ? "active" : ""} onClick={() => { setQuickNum(1); handleQuickSelect('last3Days'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 1} readOnly /> Last 3 Days</li>
                                                                <li className={quickNum === 2 ? "active" : ""} onClick={() => { setQuickNum(2); handleQuickSelect('last7Days'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 2} readOnly /> Last 7 Days</li>
                                                                <li className={quickNum === 3 ? "active" : ""} onClick={() => { setQuickNum(3); handleQuickSelect('last15Days'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 3} readOnly /> Last 15 Days</li>
                                                                <li className={quickNum === 4 ? "active" : ""} onClick={() => { setQuickNum(4); handleQuickSelect('lastMonth'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 4} readOnly /> Last Month</li>
                                                                <li className={quickNum === 5 ? "active" : ""} onClick={() => { setQuickNum(5); handleQuickSelect('last3Months'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 5} readOnly /> Last 3 Months</li>
                                                                <li className={quickNum === 6 ? "active" : ""} onClick={() => { setQuickNum(6); handleQuickSelect('last6Months'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 6} readOnly /> Last 6 Months</li>
                                                                <li className={quickNum === 7 ? "active" : ""} onClick={() => { setQuickNum(7); handleQuickSelect('currentYear'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 7} readOnly /> Current Year</li>
                                                                <li className={quickNum === 8 ? "active" : ""} onClick={() => { setQuickNum(8); handleQuickSelect('previousYear'); }}>
                                                                    <input type="radio" name="check" checked={quickNum === 8} readOnly /> Previous Year</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                        </div> */}
                  

                  
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="d-flex flex-row-reverse" style={{ marginRight: "30px" }}>
          <button className={`${tableView === true ? "btn btn-primary" : ""}`} onClick={() => setTableView(true)}><FaTable size={20} color="#000" /></button>
          <button className={`${tableView === false ? "btn btn-primary" : ""}`} style={{ marginRight: "10px" }} onClick={() => setTableView(false)}><CiBoxList size={20} color="#000" /></button>
        </div>

        {tableView === false ? <> <AdminViewTable TableData={eventsData} totalPages={totalPages} currentPage={currentPage} handlePageChange={handlePageChange} /></> : <>
          <div className="imageListShowDiv">
            <div className="container">
              <Row>
                {eventsData && eventsData.length > 0 ? (
                  eventsData
                  // .filter(item => item.theme_name === themeLabel)
                  .map((item, i) => {
                    const media = [
                      ...item.photos.map((pics) => ({ type: 'image', url: pics })),
                      ...item.videos.map((vid) => ({ type: 'video', url: vid })),
                    ];
                    return (
                      <Col md="4" key={i}>
                        <div className="viewThemeDiv">
                          <div className="flip-card">
                            <div className="flip-card-inner">
                              <div className="flip-card-front">
                                <div className="flip-card-front-in">
                                <img src={item.photos[0]?.photo_url} alt="Image not uploaded" />
                                  <div className="frontThemName">
                                    <h1> Event Name: <strong>{item.event_name ? item.event_name : ""}</strong></h1>
                                  </div>
                                </div>
                              </div>
                              <div className="flip-card-back">
                                <div className="flipCardBackIn">
                                  <h1> Event Name: <strong>{item.event_name ? item.event_name : ""}</strong></h1>
                                  <p> Theme  Name: <strong>{item.theme_name ? item.theme_name : ""}</strong></p>
                                  <p>Sub Theme:
                                          <strong>{item.sub_themes? item.sub_themes[0]: ""}</strong>
                                        </p>
                                        <p>Event Date:
                                          <strong>{item.event_date? Helper.formatDate(item.event_date): ""}</strong>
                                        </p>
                                  <p> Mode of Implementation: <strong>{item.implemnt_mode ? item.implemnt_mode : ""}</strong></p>
                                  <p> Type of Event: <strong>{item.event_type ? item.event_type : ""}</strong></p>
                                  <p> Number of Events: <strong>{item.number_events ? item.number_events : ""}</strong></p>
                                  <p> Does this Event include a technological intervention?: <strong>{item.isEventTechIntervention ? item.isEventTechIntervention : ""}</strong></p>
                                  <p> Have All Participants Attending Event Taken The Pledge?: <strong>{item.haveParticipantPledge ? item.haveParticipantPledge : ""}</strong></p>
                                  <p> Total Participants:<strong>{item?.number_participant_age8to11 +item?.number_participant_age14to18 + item?.number_participant_age11to14 + item?.number_participant_age3to8 + item?.number_participant_age18plus}</strong></p>
                                  <p> State/UT/AB: <strong>{item.state ? item.state : ""}</strong></p>
                                  <p> District: <strong>{item.district ? item.district : ""}</strong></p>
                                  <p> City: <strong>{item.city ? item.city : ""}</strong></p>
                                </div>
                              </div>
                            </div>

                            <div className="themCarslDiv">
                                    <Slider {...settings}>
                                      {/* {console.log} */}
                                      {media.map((mediaItem, j) => (
                                        <div className="slide01newnew" key={j}>
                                          <div
                                            className="btn-login-signup"
                                            onClick={() =>
                                              handleMediaClick(
                                                mediaItem.type === "image" ? mediaItem?.url?.photo_url : mediaItem.url,
                                                mediaItem.type
                                              )
                                            }
                                          >
                                            {mediaItem.type === "image" ? (
                                              <img
                                                src={
                                                  mediaItem?.url?.photo_url
                                                }
                                                alt="Slider Media"
                                              />
                                            ) : (
                                              <video
                                                style={{
                                                  width: "100%",
                                                  height: 71,
                                                }}
                                              >
                                                <source
                                                  src={
                                                    mediaItem.url
                                                  }
                                                  type="video/mp4"
                                                />
                                                Your browser does not support
                                                the video tag.
                                              </video>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </Slider>
                                  </div>
                            <div className="actionBtnDivnew">
                              <ul>
                                <li>
                                  <BiSolidLike color="#089c1e" size={26} /> {item.like_count ? item.like_count : ""}
                                </li>
                                <li>
                                  <BiSolidDislike size={26} color="#f04" /> {item.dislike_count ? item.dislike_count : ""}
                                </li>
                              </ul>
                            </div>

                          </div>
                        </div>
                      </Col>
                    );
                  })
                ) : (
                  <p>Event not found.</p>
                )}
              </Row>

              {totalPages > 1 ?
                <div className="mb-3">
                  <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>Previous</button>
                  <span>Page {currentPage} of {totalPages}</span>
                  <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} > Next </button>
                </div>
                : ""}
            </div>
          </div>
        </>}

      </div>
      <MyVerticallyCenteredModal show={modalShow} onHide={() => setModalShow(false)} mediaUrl={mediaUrl} isVideo={isVideo} setModalShow={(value) => { setModalShow(value) }} />
    </>
  );
}

export default DistrictViewTheme;

function MyVerticallyCenteredModal(props) {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
      <span onClick={() => props.setModalShow(false)} className="closebtn">X</span>
      <Modal.Body style={{ padding: 20 }}>
        {props.isVideo ? (
          <video controls style={{ width: '100%', height: 500 }}>
            <source src={props.mediaUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img src={props.mediaUrl} alt="" style={{ width: '100%' }} />
        )}
      </Modal.Body>
    </Modal>
  );
}